import React, { FunctionComponent } from 'react'
import classnames from 'classnames'

import WebsiteSelector from './WebsiteSelector'
import UserMenu from './UserMenu'
import Svg from '../../Svg'

import { Website } from '../../../typings/website'

import styles from './styles.module.css'

interface TopProps {
  className: string
  userName: string
  userInitials: string
  activeWebsite: Website
  websites: Array<Website>
  updateActiveWebsite(w: Website): void
}

const Top: FunctionComponent<TopProps> = ({
  className,
  userName,
  userInitials,
  activeWebsite,
  websites,
  updateActiveWebsite,
}) => (
  <header className={classnames(className, styles.container)} data-rv="header">
    <div className={styles.sizer}>
      <div className={styles.logo} data-rv="logo-container">
        <Svg name="rv-logo" />
      </div>
      <div className={styles.innerContainer} data-rv="header-menu">
        <WebsiteSelector
          activeWebsite={activeWebsite}
          websites={websites}
          updateActiveWebsite={updateActiveWebsite}
        />
        <UserMenu userName={userName} userInitials={userInitials} />
      </div>
    </div>
  </header>
)

export default Top
